import * as React from 'react';
import { Button, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Radium from 'radium';

import MenuLink from './menu_link';
import MenuButtons from './../social_buttons';

@Radium
export default class Menu extends React.Component {
  handleSelect() {
    location.hash = this.href;
  }

  render() {
    const logo = require('../claim/claim_image.jpg');

    return (
      <Navbar fixedTop collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <img src={logo} alt="" className="navbar-brand-img" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <MenuLink to="/workshopy">Workshopy</MenuLink>
            <MenuLink to="/spolky">Spolky</MenuLink>
            <MenuLink to="/navstivili-jsme">Navštívili jsme</MenuLink>
            <MenuLink to="/ke-stazeni">Ke stažení</MenuLink>
            <MenuLink data-tid="menu-link-contact" to="/kontakt">Kontakt</MenuLink>
          </Nav>
          <Nav pullRight>
            <MenuButtons style={styles.social} />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const styles = {
  social: {
    display: 'table',
    margin: '13px 15px 0 7px',
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/menu/index.jsx